
import Vue from "vue";
import TextField from "@/components/molecules/TextField.vue";
import SignUpConfirmCode from "@/components/organisms/SignUpConfirmCode.vue";
import { Auth } from "aws-amplify";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { TextField, SignUpConfirmCode },
  props: {
    propEmail: {
      type: String,
      default: "",
    },
    propMessage: {
      type: String,
      default: "",
    },
  },
  name: "signup",
  created() {
    const { propEmail, propMessage } = this;

    this.email = propEmail;
    this.message = propMessage;
  },
  data() {
    return {
      confirmCode: "",
      email: "",
      message: "",
      errorMessage: "",
      inputConfirmCode: false,
    };
  },
  methods: {
    async complete() {
      const { email } = this;
      this.$router.push({ name: "signIn", params: { email } });
    },
    async resend() {
      const { email } = this;
      
      // リクエスト開始時にメッセージをクリア
      this.message = "";
      this.errorMessage = "";

      // バリデーション
      if (!email) {
        this.errorMessage = this.$t('resendConfirmCodePage.validation.emailRequired') as string;
        return;
      }
      // eslint-disable-next-line no-useless-escape
      if (!email.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/)) {
        this.errorMessage = this.$t('resendConfirmCodePage.validation.invalidEmailFormat') as string;
        return;
      }

      try {
        await Auth.resendSignUp(email);
        this.message = this.$t('resendConfirmCodePage.validation.codeSent') as string;
        this.confirmCode = "";
        this.inputConfirmCode = true;
      } catch (err) {
        const error = err as any;
        if (error.code === "InvalidParameterException") {
          this.errorMessage = this.$t('resendConfirmCodePage.validation.userAlreadyConfirmed') as string;
        } else if (error.code === "UserNotFoundException") {
          this.errorMessage = this.$t('resendConfirmCodePage.validation.userNotFound') as string;
        } else if (error.code === "LimitExceededException") {
          this.errorMessage = this.$t('resendConfirmCodePage.validation.limitExceeded') as string;
        } else {
          this.errorMessage = `${this.$t('resendConfirmCodePage.validation.genericError')} ${JSON.stringify(error)}`;
        }
      }
    },
  },
});
